import {insertHtmlFragment} from "@otto-ec/global-resources/dom";

export class ConnectFour {

    async init() {
        const connectFourElement: HTMLElement | null = document.querySelector('.promo_staticcontent--connect-four');
        if (connectFourElement) {
            await fetch("/connectfour/content.html").then(response => {
                if (response.ok) {
                    return response.text();
                } else {
                    throw new Error("[FT3] Connect Four loading failed.");
                }
            }).then(connectFourHtml => {
                insertHtmlFragment(connectFourHtml, connectFourElement);
            }).catch(error => {
                console.error(error.message);
            })
        } else {
            console.error("[FT3] Connect Four element not found.");
        }
    }

}